import React from 'react';
import './InfiniteLoader.scss';

const InfiniteLoader = () => {
  return (<div className="loader-wrap"><div className="loader"></div></div>);
};

export default InfiniteLoader;
